import Header from './components/Header';
import Hero from './components/Hero';
import SectionIndex from './components/SectionIndex';
import SectionCarousel from './components/SectionCarousel';
import SectionRanking from './components/SectionRanking';
import SectionAbout from './components/SectionAbout';
import SectionFeatures from './components/SectionFeatures';
import SectionContact from './components/SectionContact';
import SectionMedia from './components/SectionMedia';
import SectionApp from './components/SectionApp';
import SectionFaq from './components/SectionFaq';
import SectionComments from './components/SectionComments';
import SectionUpdates from './components/SectionUpdates';
import SectionTopics from './components/SectionTopics';
import SectionCards from './components/SectionCards';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <SectionIndex />
        <SectionCarousel />
        <SectionRanking />
        <SectionAbout />
        <SectionFeatures />
        <SectionContact />
        <SectionMedia />
        <SectionApp />
        <SectionFaq />
        <SectionComments />
        <SectionUpdates />
        <SectionTopics />
        <SectionCards />
      </main>
      <Footer />
    </div>
  );
}